import axios from 'axios';
import getRequestData from "@/helpers/get-request-data";
import getRequestHeaders from "@/helpers/get-request-headers";
import Service from "@/abstracts/service";

class keyNaveService extends Service {
    constructor() {
        super('p00048');
    }

    /**
     * @param {Number} page
     * @param {Number} limit
     * @param {Array} filter
     * @returns {Promise<Object>}
     */
    listLicenses(page = 1, limit = 10, filter = []) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_LICENSE_LIST_LICENSE",
                page: page,
                limit: limit,
                filter: filter,
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let returnValue = {
                        list: [],
                        total: 0
                    };

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        returnValue = {
                            list: payload.data.list,
                            total: payload.data.total
                        };
                    }

                    resolve(returnValue);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {Number} license
     * @returns {Promise<Object>}
     */
    getLicense(license) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_LICENSE_GET_LICENSE",
                license: license
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let license = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        license = payload.data;
                    }

                    resolve(license);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {Number} amount
     * @param {String} party
     * @param {String} order
     * @param {String} product
     * @param {String} purchaseDate
     * @returns {Promise<Object>}
     */
    createLicense(amount, party, order, product, purchaseDate) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_LICENSE_CREATE_LICENSE",
                amount: amount,
                party: party,
                order: order,
                product: product,
                purchaseDate: purchaseDate
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let createLicense = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        createLicense = payload.data;
                    }

                    resolve(createLicense);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {String} license
     * @param {String} status
     * @returns {Promise<Object>}
     */
    updateLicense(license, status) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_LICENSE_UPDATE_LICENSE",
                license: license,
                status: status
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let updateLicense = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        updateLicense = payload.data;
                    }

                    resolve(updateLicense);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {String} license
     * @returns {Promise<Object>}
     */
    deleteLicense(license) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_LICENSE_DELETE_LICENSE",
                license: license
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let deleteLicense = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        deleteLicense = payload.data;
                    }

                    resolve(deleteLicense);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }
}

export default new keyNaveService();